<template>
  <div class="villas-carousel">
    <swiper ref="villas-carousel" :options="swiperOptions" @progress="updateSwiperEnd">
      <swiper-slide v-for="(villa, index) in villas" :key="villa.id">
        <villa-preview :villa="villa" :length="villas.length" :position="index"></villa-preview>
      </swiper-slide>
    </swiper>

    <button v-if="!isEnd" type="button" class="overlay-end" @click="slideNext()">
      <i class="icon-arrow-medium-right"></i>
    </button>

    <div class="nav-buttons">
      <button type="button" class="btn-prev" @click="slidePrev()">
        <i class="icon-arrow-medium-left"></i>
      </button>

      <button type="button" class="btn-next" @click="slideNext()">
        <i class="icon-arrow-medium-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import villas from '../../dist/data/villas.json'

  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  import VillaPreview from './villa-preview.vue'

  export default {
    components: {
      Swiper,
      SwiperSlide,
      VillaPreview
    },
    props: {
      villas: {
        type: Array,
        required: false,
        default: () => villas
      }
    },
    data() {
      return {
        isEnd: false,
        swiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 6,
          centeredSlides: false,
          loop: false,
        }
      }
    },
    // computed: {
    //   swiper() {
    //     return this.$refs['villas-carousel'].$swiper
    //   },
    // },
    methods: {
      slidePrev() {
        this.$refs['villas-carousel'].$swiper.slidePrev()
      },
      slideNext() {
        this.$refs['villas-carousel'].$swiper.slideNext()
      },
      updateSwiperEnd() {
        this.isEnd = this.$refs['villas-carousel'].$swiper.isEnd
      }
    },
    mounted() {
      // this.leftSlider.slideTo(3, 1000, false)
    }
  }
</script>

<style lang="scss">
  @import 'src/sass/variables';
  @import 'node_modules/bootstrap/scss/vendor/rfs';

  .villas-carousel {
    position: relative;

    .swiper-slide {
      background: $white;
      height: auto;
      width: 360px;
    }

    .overlay-end {
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      width: 170px;
      height: 100%;
      background: $body-bg;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba($body-bg, 0.7) 40%, rgba($body-bg, 1) 80%);

      i {
        position: absolute;
        top: 50%;
        right: 25px;
        transform: translateY(-50%);

        &::before {
          @include font-size(3rem);
        }
      }
    }

    .nav-buttons {
      position: absolute;
      top: 18%;
      left: 0;
      transform: translateX(-50%);
      z-index: 5;

      .btn-prev,
      .btn-next {
        position: relative;
        display: block;
        background: $white;
        opacity: 1;
        transition: opacity 250ms ease-in-out;
        width: 54px;
        height: 54px;

        i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: $secondary;

          &::before {
            @include font-size(1.5rem);
          }
        }

        &:hover {
          opacity: 0.8;
        }

        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }

  // SM
  @media only screen and (max-width: 575px) {
    .villas-carousel {
      .nav-buttons {
        top: 6%;
        transform: translateX(-20%);
      }
    }
  }
</style>